import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { TeamDto } from '../../../models/dtos/team.dto';
import { Errors } from '../../errors';
import getTeamsRequest from './getTeams.repository';

type InitialState = {
  loading: boolean;
  data?: TeamDto[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getTeams = createAsyncThunk('getTeams', (countryName: string) => {
  return getTeamsRequest(countryName);
});

const getTeamsSlice = createSlice({
  name: 'getTeams',
  initialState,
  reducers: {
    getTeamsReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTeams.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getTeams.fulfilled,
      (state, action: PayloadAction<TeamDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getTeams.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getTeamsSlice.reducer;
export const { getTeamsReset } = getTeamsSlice.actions;
